import { render, staticRenderFns } from "./template-content.vue?vue&type=template&id=921eed16&scoped=true"
import script from "./template-content.vue?vue&type=script&lang=js"
export * from "./template-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921eed16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921eed16')) {
      api.createRecord('921eed16', component.options)
    } else {
      api.reload('921eed16', component.options)
    }
    module.hot.accept("./template-content.vue?vue&type=template&id=921eed16&scoped=true", function () {
      api.rerender('921eed16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/template-content.vue"
export default component.exports